import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  takisGridItem: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    margin: "0 auto",
    padding: "0 2rem"
  },
  cursorPointer: {
    cursor: "pointer",
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    position: "relative",
    margin: "0 auto",
    width: "100%",
    paddingBottom: "14rem",

    [theme.breakpoints.up('lg')]: {
      paddingBottom: "18rem"
    },
    [theme.breakpoints.up('xl')]: {
      paddingBottom: "23rem"
    }
  },
  imageContainerWide: {
    paddingBottom: "14rem",
    [theme.breakpoints.up('lg')]: {
      paddingBottom: "18rem"
    },
    [theme.breakpoints.up('xl')]: {
      paddingBottom: "27rem"
    }
  },
  frontImage: {
    position: "absolute",
    maxWidth: "100%",
    maxHeight: "100%",
    bottom: "0",
    [theme.breakpoints.up('lg')]: {
      maxWidth: "22rem",
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: "30rem"
    }
  },
  frontImageWide: {
    position: "absolute",
    bottom: "0",
    maxHeight: "100%",
    maxWidth: "100%",
  },
  frontImageHoverLeft: {
    transform: "rotate(-5deg)"
  },
  frontImageHoverRight: {
    transform: "rotate(5deg)"
  },
  backgroundImage: {
    position: "absolute",
    top: "7rem",
    width: "5rem",
    transition: "transform .1s ease-in-out",
    transform: "rotate(-75deg)"
  },
  backgroundSprite: {
    position: "absolute",
  },
  delayedAnimation: {
    transition: "transform .2s ease-in-out",
  },
  backgroundImageHover: {
    transform: "rotate(0) scale(4.2)"
  },
  ctaContainer: {
    marginTop: "1.5rem",
    margin: "0 auto"
  },
  ctaHoverRight: {
    transition: '.5s ease',
    transform: 'perspective(62.5rem) rotate(8deg)',
    backgroundColor: theme.palette.darkPurple
  },
  ctaHoverLeft: {
    transition: '.5s ease',
    transform: 'perspective(62.5rem) rotate(-8deg)',
    backgroundColor: theme.palette.darkPurple
  },
  cta: {
    fontSize: '2.2rem',
    margin: "0.625rem 0"
  },
  hidden: {
    display: "none"
  },
  description: {
    width: '100%',
    height: 'auto',
    fontSize: '1.125rem',
    color: theme.palette.white,
    textAlign: 'center',
    "& p": {
      display: 'inline-block'
    }
},
}));
